"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppMenuItem = void 0;
var _reactRouterDom = require("react-router-dom");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _faAngleDown = require("@fortawesome/free-solid-svg-icons/faAngleDown");
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AppMenuItem = require("./AppMenuItem.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AppMenuItem = /*#__PURE__*/(0, _react.memo)(function (props) {
  var open = props.open,
    name = props.name,
    onToggle = props.onToggle,
    _props$data = props.data,
    icon = _props$data.icon,
    label = _props$data.label,
    subItems = _props$data.subItems,
    parentUrl = _props$data.url,
    parentOnClick = _props$data.onClick,
    parentTargetType = _props$data.targetType,
    parentLinkType = _props$data.linkType,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel;
  var classes = (0, _AppMenuItem.useStyles)();
  var listRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  var toggleHandler = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    onToggle(name);
  }, [name, onToggle]);
  (0, _react.useEffect)(function () {
    if (listRef.current) {
      setHeight(open ? listRef.current.offsetHeight : 0);
    }
  }, [open, listRef]);
  var parentLinkContent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon && /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.icon
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: icon
    })), label, subItems && /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(classes.indicator, height > 0 ? classes.rotateIndicator : '')
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faAngleDown.faAngleDown,
      size: "sm"
    })));
  }, [classes.icon, classes.indicator, classes.rotateIndicator, height, icon, label, subItems]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, parentLinkType === 'link' ? /*#__PURE__*/_react["default"].createElement("a", {
    href: parentUrl,
    className: classes.toggler,
    onClick: subItems ? toggleHandler : parentOnClick,
    target: parentTargetType
  }, parentLinkContent) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: parentUrl,
    activeClassName: "active",
    className: classes.toggler,
    onClick: subItems ? toggleHandler : parentOnClick,
    target: parentTargetType
  }, parentLinkContent), subItems && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper,
    style: {
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement("nav", {
    ref: listRef
  }, subItems.map(function (item, index) {
    var url = item.url,
      label = item.label,
      targetType = item.targetType,
      linkType = item.linkType,
      onClick = item.onClick;
    if (linkType === 'link') {
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: classes.link,
        key: index,
        href: url,
        target: targetType,
        onClick: onClick
      }, showLabel && /*#__PURE__*/_react["default"].createElement("span", {
        className: classes.prefix
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: classes.prefixContent
      }, label[0])), label);
    }
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
      exact: false,
      activeClassName: "active",
      className: classes.link,
      key: index,
      to: "".concat(parentUrl).concat(url),
      target: targetType,
      onClick: onClick
    }, showLabel && /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.prefix
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.prefixContent
    }, label[0])), label);
  }))));
});
exports.AppMenuItem = AppMenuItem;